import type { RefObject } from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import Button from 'flow/components/ui-components/Button';
import Tooltip from 'flow/components/ui-components/Tooltip';

interface Props {
    disabled?: boolean;
    fileInputRef: RefObject<HTMLInputElement>;
    onAddAttachment: (file?: File) => void;
}

const AttachmentButton = ({
    disabled,
    fileInputRef,
    onAddAttachment,
}: Props) => {
    const { i18next } = useAppContext();

    return (
        <>
            <Tooltip label={i18next.t('Chat.Tooltip.Attachment')}>
                <Button
                    onClick={(e) => {
                        e.preventDefault();
                        fileInputRef.current?.click();
                    }}
                    iconKey="attachment"
                    className="size-8! shrink-0 bg-black/5 text-gray-700 hover:bg-black/10"
                    disabled={disabled}
                />
            </Tooltip>
            <input
                ref={fileInputRef}
                type="file"
                className="hidden"
                onChange={(e) => {
                    onAddAttachment(e.target.files?.[0]);
                    e.target.value = '';
                }}
            />
        </>
    );
};

export default AttachmentButton;
